/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { CircularProgress } from "@mui/material";
import { HomeEventResultItem } from "layout/homepage/feeds/feed-component/event/common/event-result-item";
import { isArrayNotEmpty } from "cms/utils/empty-exists";
import { NavLink } from "react-router-dom";
import { SkipDuringPrerender } from "cms/shared/hyrdation/avoid-prerender";

const EventsStyleFeed = (props) => {
    const type = props?.type;
    const title = props?.title;
    const models = props?.models;
    const links  = props?.links ?? [];
    const empty_message = props?.empty_message;
    const loaded = props?.loaded;
    const customCssClass = props?.customCssClass;

    // const eventType = ["model.event", "model.meeting"];
    const hasModels = loaded && isArrayNotEmpty(models);

    return (
        <div className={`feed-component-container home ${customCssClass}`}>
            <div className="feed-component-header-clear">
                <div className="feed-component-title-wrapper">
                    <h2 className="feed-component-title-link">{title}</h2>
                    <div className="feed-component-title-underline"></div>
                </div>
                <div className="feed-component-links-wrapper">
                    {links &&
                        links.map((link, index) => {
                            const { path, text } = link;
                            return (
                                <div key={index} className="feed-component-link-item">
                                    {/*<a href={link.path}>{link.text}</a>*/}
                                    <NavLink to={path}>{text}</NavLink>
                                </div>
                            );
                        })}
                </div>
            </div>
            <div className="feed-component-panel-clear">
                <div style={{ height: "100%" }} className="feed-component-panel-inner">
                    <SkipDuringPrerender>
                        {!loaded && (
                            <div className="spinner-container">
                                <CircularProgress />
                            </div>
                        )}
                        {loaded && !hasModels && <div className="empty-message">{empty_message}</div>}
                        {models &&
                            models.map((model, index) => {
                                const { guid } = model;
                                return <HomeEventResultItem type={type} key={`${guid}${index}`} model={model} />;
                            })}
                    </SkipDuringPrerender>
                </div>
            </div>
        </div>
    );
};

export { EventsStyleFeed };
